import { RadioGroup } from '@mui/material';
import type { VoidFunctionComponent } from 'react';

import {
  ExceptionPackageScope,
} from '../../../../../shared/issuesV2';
import {
  FormGroup,
  icons,
} from '../../../generic';
import LabeledRadio from '../../../generic/Forms/LabeledRadio';
import TooltipIcon from '../../../generic/TooltipIcon';
import { TOOLTIP_MAP } from './consts';
import type { SetState } from '../../../../types';
import { verify_subscription } from '../../../../utils';
import Tooltip from '../../../generic/Tooltip';

type Props = {
  packageScope: ExceptionPackageScope;
  setPackageScope: SetState<ExceptionPackageScope>
};

const PackageScopeOptions: VoidFunctionComponent<Props> = ({ packageScope, setPackageScope }) => {
  const isPremium = verify_subscription('premium');
  return (
    <FormGroup legend="Which versions?" spacing="sm">
      <RadioGroup
        className="radio-filter-group"
        value={packageScope}
        onChange={(_event, value) => setPackageScope(value as ExceptionPackageScope)}
      >
        <div className="radio-filter-group-checks">
          <LabeledRadio
            label={
              <span>
                Selected version{' '}
                <TooltipIcon
                  tooltip={TOOLTIP_MAP[ExceptionPackageScope.SelectedVersion]}
                  icon={icons.circleQuestion}
                  id="selected-version-tooltip"
                />
              </span>
            }
            value={ExceptionPackageScope.SelectedVersion}
          />
          <LabeledRadio
            label={
              <Tooltip
                id="all-versions-disabled-tooltip"
                tooltip="Ignoring for all versions requires a premium subscription."
                showTooltip={!isPremium}
              >
                <span>
                  All versions{' '}
                  <TooltipIcon
                    tooltip={TOOLTIP_MAP[ExceptionPackageScope.AllVersions]}
                    icon={icons.circleQuestion}
                    id="all-versions-tooltip"
                    // Only show if the option isn't disabled.
                    showTooltip={isPremium}
                  />
                </span>
              </Tooltip>
            }
            value={ExceptionPackageScope.AllVersions}
            isDisabled={!isPremium}
          />
        </div>
      </RadioGroup>
    </FormGroup>
  );
};

export default PackageScopeOptions;
